<div class="container">
    <div class="row mt-5 vd-fade">
        <div class="col-sm-12 col-lg-12">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Claim type</th>
                        <th>Claim value</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let key of getKeys()">
                        <td>{{ key }}</td>
                        <td>{{ getValue(key) | json }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    
</div>